import { FC, ReactElement } from 'react';

import { NavPages } from '@pp/core/src/components/nav/navPages/NavPagesConnected';
import { useGameConfig } from '@pp/core/src/config/GameConfigProvider';
import { useAudioTrigger } from '@pp/core/src/controllers/audioController/hooks';
import { useMedia } from '@pp/core/src/hooks/useMedia';
import { Logger } from '@pp/core/src/logger/Logger';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';
import { useCoreDispatch } from '@pp/core/src/store/CoreStore';
import { useHeaderSlice } from '@pp/core/src/store/slices/header/selectors';
import { headerActions } from '@pp/core/src/store/slices/header/slice';
import { HeaderModal } from '@pp/core/src/store/slices/header/types';

import styles from './MoreInfo.module.css';

export const MoreInfo: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();
  const audioTrigger = useAudioTrigger();
  const inDesktopMode = useMedia('(min-width: 1024px');
  const openedModal = useHeaderSlice.getCoreOpenedModal();
  const {
    config: { helpConfig },
  } = useGameConfig();
  const helpChapters = Object.keys(helpConfig);

  const handleClick = () => {
    audioTrigger.play({ name: 'menuClick' });
    if (openedModal === HeaderModal.Help) {
      dispatch(headerActions.setOpenedModal(null));
    } else {
      Logger.logEvent('click', 'openHelp', Date.now(), 1, '', false);
      if (inDesktopMode) {
        dispatch(headerActions.setOpenedModal(HeaderModal.Help));
        //dispatch(headerActions.setSelectedHelpPage(helpChapters[7])); // TODO core remvoed setSelectedHelpPage function
      } else {
        dispatch(headerActions.pushNavRoute(NavPages.HOME));
        dispatch(headerActions.pushNavRoute(NavPages.HELP));
        dispatch(headerActions.pushNavRoute(helpChapters[7]));
      }
    }
  };

  return (
    <div className={styles.modalMoreInfo} onClick={handleClick}>
      <L10nText tk="ABOUT_HASH" />
    </div>
  );
};
